import React from "react";
import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ScheduleIcon from "@mui/icons-material/Schedule";

const automationFeatures = [
  {
    icon: <AlarmOnIcon sx={{ fontSize: 40, color: "#fff" }} />,
    bgColor: "#903AF2",
    title: "Mensajes Automáticos",
    description:
      "Programá correos de confirmación, recordatorios y mensajes de bienvenida para mejorar la experiencia del huésped.",
  },
  {
    icon: <MarkEmailReadIcon sx={{ fontSize: 40, color: "#fff" }} />,
    bgColor: "#903AF2",
    title: "Confirmaciones Instantáneas",
    description:
      "Los huéspedes reciben una confirmación inmediata al realizar una reserva, generando confianza y seguridad.",
  },
  {
    icon: <NotificationsActiveIcon sx={{ fontSize: 40, color: "#fff" }} />,
    bgColor: "#903AF2",
    title: "Recordatorios Programados",
    description:
      "No olvides ni una reserva: Ubika envía recordatorios para garantizar que tus huéspedes lleguen informados.",
  },
  {
    icon: <ScheduleIcon sx={{ fontSize: 40, color: "#fff" }} />,
    bgColor: "#903AF2",
    title: "Optimización de Tareas",
    description:
      "Automatizá pagos recurrentes y asignación de habitaciones para ahorrar tiempo y evitar errores.",
  },
];

function FeaturesAutomation() {
  return (
    <Box
      sx={{
        background: "linear-gradient(0deg, #d2c2f2, #903AF2)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        {/* Título */}
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          mb={8}
          sx={{
            fontFamily: "'Red Hat Display', sans-serif",
            color: "#fff",
          }}
        >
          Automatización Inteligente para tu Hospedaje
        </Typography>

        {/* Features */}
        <Grid container spacing={6}>
          {automationFeatures.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper
                elevation={4}
                sx={{
                  backgroundColor: feature.bgColor,
                  borderRadius: "12px",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  {feature.icon}
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "'Red Hat Display', sans-serif",
                      color: "#ffffff",
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    mt={1}
                    sx={{
                      fontFamily: "'Merriweather Sans', sans-serif",
                      color: "#ffffff",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default FeaturesAutomation;
